import { NavigationGroup } from './sidebar.model'

export const navigationGroups: NavigationGroup[] = [
    {
        label: 'Dashboard',
        icon: 'lucideLayoutDashboard',
        expanded: true,
        items: [
            {
                label: 'Home',
                icon: 'lucideHome',
                routerLink: '/admin',
                exact: true,
            },
        ],
    },
    {
        label: 'Platform Management',
        icon: 'lucideDatabase',
        expanded: true,
        items: [
            {
                label: 'Benefits',
                icon: 'lucideGift',
                routerLink: '/admin/benefits',
            },
            { label: 'Users', icon: 'lucideUsers', routerLink: '/admin/users' },
            {
                label: 'Vendors',
                icon: 'lucideStore',
                routerLink: '/admin/vendors',
            },
            {
                label: 'Clients',
                icon: 'lucideBriefcase',
                routerLink: '/admin/clients',
            },
            {
                label: 'Categories',
                icon: 'lucideTag',
                routerLink: '/admin/categories',
            },
            {
                label: 'Raffles',
                icon: 'lucidePartyPopper',
                routerLink: '/admin/raffles',
            },
            {
                label: 'Landing Page',
                icon: 'lucideLayers',
                routerLink: '/admin/landing-page',
            },
        ],
    },
    {
        label: 'System',
        icon: 'lucideSettings',
        items: [
            {
                label: 'Settings',
                icon: 'lucideSettings',
                routerLink: '/admin/settings',
            },
        ],
    },
]
